module.exports = __webpack_public_path__ + "img/set_bg.87876aa7.png";